import { useEffect } from "react";
import L from "leaflet";
import { MapContainer, Marker, Polygon, Polyline, TileLayer, Tooltip, useMap } from "react-leaflet";
import type { GeoFeature, MapCluster } from "../types";

function hofIcon(feature: GeoFeature, selectedClusterId?: string | null) {
  const clusterId = feature.properties.cluster_id;
  const color = feature.properties.cluster_color || (feature.properties.cluster_outlier ? "#94A3B8" : "#EC4899");
  const dimmed = Boolean(selectedClusterId && clusterId !== selectedClusterId);
  return L.divIcon({
    className: "hof-marker-wrap",
    html: `<span class="hof-marker${dimmed ? " dimmed" : ""}" style="--hof-color:${color}"></span>`,
    iconSize: [18, 18],
    iconAnchor: [9, 9],
  });
}

function FitPoints({ features }: { features: GeoFeature[] }) {
  const map = useMap();
  useEffect(() => {
    if (!features.length) return;
    const bounds = L.latLngBounds(features.map((feature) => [feature.geometry.coordinates[1], feature.geometry.coordinates[0]]));
    map.fitBounds(bounds, { padding: [42, 42], maxZoom: 16 });
  }, [features, map]);
  return null;
}

export function ResultMap({ features, selectedCluster }: { features: GeoFeature[]; selectedCluster?: MapCluster | null }) {
  const first = features[0]?.geometry.coordinates || [11.576, 48.137];
  const selectedFeatures = selectedCluster
    ? features.filter((feature) => feature.properties.cluster_id === selectedCluster.id)
    : features;
  const hull = selectedCluster?.hull_geojson?.coordinates[0].map(([lon, lat]) => [lat, lon] as [number, number]) || [];
  const route = selectedCluster?.route.geometry?.coordinates.map(([lon, lat]) => [lat, lon] as [number, number]) || [];
  return <MapContainer className="leaflet-map" center={[first[1], first[0]]} zoom={14} zoomControl={true} scrollWheelZoom={true}>
    <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
    {hull.length >= 3 && <Polygon positions={hull} pathOptions={{ color: selectedCluster!.color, fillColor: selectedCluster!.color, fillOpacity: 0.08, weight: 2, dashArray: "6 5" }} />}
    {route.length >= 2 && <Polyline positions={route} pathOptions={{ color: selectedCluster!.color, weight: 5, opacity: 0.82 }} />}
    {features.map((feature) => <Marker key={feature.id} position={[feature.geometry.coordinates[1], feature.geometry.coordinates[0]]} icon={hofIcon(feature, selectedCluster?.id)}><Tooltip direction="top" offset={[0, -8]}>{feature.properties.name}{feature.properties.cluster_id && <><br /><small>{feature.properties.cluster_id.replace("cluster-", "Gebiet ")}</small></>}<br /><small>{feature.geometry.coordinates[1].toFixed(6)}, {feature.geometry.coordinates[0].toFixed(6)}</small></Tooltip></Marker>)}
    <FitPoints features={selectedFeatures} />
  </MapContainer>;
}
